const HTTP = 'http://';
const HTTPS = 'https://';
export default function isErrorLink(link) {
  // we want to invert the validity for this function
  return !(
    // valid if it's a substring of HTTP
    HTTP.startsWith(link)
    // or a substring of HTTPS
    || HTTPS.startsWith(link)
    // or contains something like "http://www."
    || link.match(/^https?:\/\/.*\..*/)
  );
}
